import OpenAI from "openai";
import { Action } from "actions/types/Action";
import { GlobalAction } from "admin/globalActions/types/GlobalAction";

const API_KEY = "sk-proj-cB5ADYGD8RbfFcOUq9ZeT3BlbkFJHVNWidjtgd7xtUBMx97o";

const openAiActions_deprecated = {
  getActionBySdg: async (
    sdgNum: number,
    globalActions: GlobalAction[],
    rejectedActions: Action[]
  ): Promise<Action> => {
    const openai = new OpenAI({
      apiKey: API_KEY,
      dangerouslyAllowBrowser: true,
    });

    // Minimize payload: Extract only title and description
    const globalSummaries = globalActions.map((a, i) => `(${i + 1}) "${a.title}": ${a.description}`).join("\n");
    const rejectedSummaries = rejectedActions.map((r, i) => `(${i + 1}) "${r.title}": ${r.description}`).join("\n");

    const aiPrompt = `
You are an expert in sustainable event planning. Your goal is to generate one new, creative action idea for an event planner working under UN SDG ${sdgNum}. The action must help them operate more sustainably.

You can be *inspired* by the following existing Global Actions but do not simply reuse or reword them:
${globalSummaries || "None provided"}

Also, avoid anything similar to these previously rejected actions:
${rejectedSummaries || "None provided"}

Please return exactly one idea as a JSON object like:
{ "title": "...", "description": "..." }

The description must be at least one sentence. Do not include explanation, preamble, or markdown.
    `.trim();

    const response = await openai.chat.completions.create({
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "user",
          content: aiPrompt,
        },
      ],
      temperature: 0.7,
      max_tokens: 300,
    });

    try {
      const action = JSON.parse(response.choices[0].message.content as string) as Action;
      return { ...action, source: "ai" };
    } catch (e) {
      console.error("Error parsing OpenAI response:", e);
      throw new Error("Failed to generate action from OpenAI");
    }
  },
};

export const API_URL = process.env.REACT_APP_API_BASE_URL;

const openAiActions = {
  getActionBySdg: async (
    sdgNum: number,
    globalActions: GlobalAction[],
    rejectedActions: Action[]
  ): Promise<Action> => {
    const resp = await fetch(`${API_URL}/useractions/action-by-sdg`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // Send the same inputs your BE expects. It will build the prompt.
      body: JSON.stringify({ sdgNum, globalActions, rejectedActions }),
      //credentials: "include", // keep cookies/session if your API needs them
    });

    if (!resp.ok) {
      const msg = await safeText(resp);
      throw new Error(`Backend error (${resp.status}): ${msg || "Unknown error"}`);
    }

    // Backend already returns `{ title, description, source: "ai" }`
    const data = (await resp.json()) as Action;
    return data;
  },
};

async function safeText(r: Response) {
  try {
    return await r.text();
  } catch {
    return "";
  }
}

export default openAiActions;